import { render, staticRenderFns } from "./CollectInfo.vue?vue&type=template&id=faa0d170&scoped=true&"
import script from "./CollectInfo.vue?vue&type=script&lang=ts&"
export * from "./CollectInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CollectInfo.vue?vue&type=style&index=0&id=faa0d170&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa0d170",
  null
  
)

export default component.exports